// extracted by mini-css-extract-plugin
module.exports = {"tag":"_2_UCi4bMJO"};
    if(module.hot) {
      // 1614934730157
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  